// import React from 'react'
// import { Box, Button, Typography } from '@mui/material'
// import { keyframes } from '@mui/system'
// import { useNavigate } from 'react-router-dom'

// /* ---------- Animations ---------- */
// const float = keyframes`
//   0%, 100% { transform: translateY(0); }
//   50%      { transform: translateY(-14px); }
// `
// const pulse = keyframes`
//   0%, 100% { transform: scale(1);    opacity: 0.55; }
//   50%      { transform: scale(1.12); opacity: 0.9; }
// `
// const fadeUp = keyframes`
//   from { opacity: 0; transform: translateY(24px); }
//   to   { opacity: 1; transform: translateY(0); }
// `
// const spin = keyframes`
//   from { transform: rotate(0deg); }
//   to   { transform: rotate(360deg); }
// `

// function NotFoundPage() {
//   const navigate = useNavigate()

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         minHeight: '100vh',
//         width: '100%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         overflow: 'hidden',
//         px: 3,
//         py: 6,
//         backgroundColor: 'var(--background-color)',
//         color: 'var(--text-color)',
//         transition: 'background-color 0.3s ease, color 0.3s ease',
//       }}
//     >
//       {/* Background glow blobs */}
//       <Box
//         sx={{
//           position: 'absolute',
//           top: '-12%',
//           left: '-8%',
//           width: { xs: 260, md: 420 },
//           height: { xs: 260, md: 420 },
//           borderRadius: '50%',
//           background: 'var(--primary-main-color)',
//           filter: 'blur(90px)',
//           animation: `${pulse} 7s ease-in-out infinite`,
//         }}
//       />
//       <Box
//         sx={{
//           position: 'absolute',
//           bottom: '-14%',
//           right: '-8%',
//           width: { xs: 280, md: 460 },
//           height: { xs: 280, md: 460 },
//           borderRadius: '50%',
//           background: 'var(--primary-dark-light-color)',
//           filter: 'blur(100px)',
//           animation: `${pulse} 9s ease-in-out infinite`,
//           animationDelay: '1.5s',
//         }}
//       />

//       {/* Decorative dashed ring */}
//       <Box
//         sx={{
//           position: 'absolute',
//           width: { xs: 340, md: 560 },
//           height: { xs: 340, md: 560 },
//           borderRadius: '50%',
//           border: '2px dashed var(--primary-main-color)',
//           animation: `${spin} 60s linear infinite`,
//           pointerEvents: 'none',
//         }}
//       />

//       {/* Floating accents */}
//       {[
//         { top: '16%', left: '14%', size: 16, delay: '0s' },
//         { top: '28%', right: '16%', size: 22, delay: '1s' },
//         { bottom: '22%', left: '20%', size: 12, delay: '2s' },
//         { bottom: '16%', right: '22%', size: 18, delay: '0.5s' },
//       ].map((dot, i) => (
//         <Box
//           key={i}
//           sx={{
//             position: 'absolute',
//             top: dot.top,
//             left: dot.left,
//             right: dot.right,
//             bottom: dot.bottom,
//             width: dot.size,
//             height: dot.size,
//             borderRadius: '50%',
//             backgroundColor: 'var(--primary-color)',
//             opacity: 0.7,
//             animation: `${float} 5s ease-in-out infinite`,
//             animationDelay: dot.delay,
//             display: { xs: i > 1 ? 'none' : 'block', sm: 'block' },
//           }}
//         />
//       ))}

//       {/* Content */}
//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 1,
//           textAlign: 'center',
//           maxWidth: 560,
//           width: '100%',
//           animation: `${fadeUp} 0.7s ease-out both`,
//         }}
//       >
//         {/* 404 with floating "0" */}
//         <Box
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: { xs: 1, md: 2 },
//             lineHeight: 1,
//             userSelect: 'none',
//           }}
//         >
//           <Typography
//             component="span"
//             sx={{
//               fontSize: { xs: 96, sm: 140, md: 180 },
//               fontWeight: 800,
//               letterSpacing: '-0.04em',
//               color: 'var(--primary-color)',
//               lineHeight: 1,
//             }}
//           >
//             4
//           </Typography>

//           <Box
//             sx={{
//               width: { xs: 88, sm: 126, md: 160 },
//               height: { xs: 88, sm: 126, md: 160 },
//               borderRadius: '50%',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               background:
//                 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark-color) 100%)',
//               boxShadow: '0 20px 50px var(--primary-main-color)',
//               animation: `${float} 4s ease-in-out infinite`,
//             }}
//           >
//             {/* Magnifier icon */}
//             <svg
//               viewBox="0 0 24 24"
//               width="52%"
//               height="52%"
//               fill="none"
//               stroke="#fff"
//               strokeWidth="1.8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               aria-hidden="true"
//             >
//               <circle cx="10.5" cy="10.5" r="6.5" />
//               <line x1="15.5" y1="15.5" x2="21" y2="21" />
//               <line x1="8" y1="8" x2="13" y2="13" />
//               <line x1="13" y1="8" x2="8" y2="13" />
//             </svg>
//           </Box>

//           <Typography
//             component="span"
//             sx={{
//               fontSize: { xs: 96, sm: 140, md: 180 },
//               fontWeight: 800,
//               letterSpacing: '-0.04em',
//               color: 'var(--primary-color)',
//               lineHeight: 1,
//             }}
//           >
//             4
//           </Typography>
//         </Box>

//         <Typography
//           variant="h4"
//           sx={{
//             mt: 3,
//             fontWeight: 700,
//             fontSize: { xs: 24, md: 32 },
//             color: 'var(--text-color)',
//           }}
//         >
//           Oops! Page not found
//         </Typography>

//         <Typography
//           sx={{
//             mt: 1.5,
//             mx: 'auto',
//             maxWidth: 440,
//             fontSize: { xs: 14, md: 16 },
//             lineHeight: 1.7,
//             color: 'var(--primary-grey-color)',
//           }}
//         >
//           The page you are looking for may have been moved, renamed or never
//           existed. Check the URL, or head back to somewhere familiar.
//         </Typography>

//         {/* Actions */}
//         <Box
//           sx={{
//             mt: 4,
//             display: 'flex',
//             flexDirection: { xs: 'column', sm: 'row' },
//             gap: 2,
//             justifyContent: 'center',
//           }}
//         >
//           <Button
//             onClick={() => navigate('/')}
//             variant="contained"
//             disableElevation
//             sx={{
//               px: 4,
//               py: 1.4,
//               borderRadius: '999px',
//               textTransform: 'none',
//               fontWeight: 600,
//               fontSize: 16,
//               color: '#fff',
//               backgroundColor: 'var(--primary-color)',
//               boxShadow: '0 10px 24px var(--primary-main-color)',
//               transition: 'transform 0.2s ease, box-shadow 0.2s ease',
//               '&:hover': {
//                 backgroundColor: 'var(--primary-color)',
//                 transform: 'translateY(-2px)',
//                 boxShadow: '0 14px 30px var(--primary-main-color)',
//               },
//             }}
//           >
//             Back to Home
//           </Button>

//           <Button
//             onClick={() => navigate(-1)}
//             variant="outlined"
//             sx={{
//               px: 4,
//               py: 1.4,
//               borderRadius: '999px',
//               textTransform: 'none',
//               fontWeight: 600,
//               fontSize: 16,
//               color: 'var(--primary-dark-color)',
//               borderColor: 'var(--primary-color)',
//               backgroundColor: 'transparent',
//               transition: 'all 0.2s ease',
//               '&:hover': {
//                 borderColor: 'var(--primary-color)',
//                 backgroundColor: 'var(--primary-dark-light-color)',
//                 transform: 'translateY(-2px)',
//               },
//             }}
//           >
//             Go Back
//           </Button>
//         </Box>

//         <Typography
//           sx={{
//             mt: 5,
//             fontSize: 12,
//             letterSpacing: '0.12em',
//             textTransform: 'uppercase',
//             color: 'var(--primary-grey-color)',
//           }}
//         >
//           Error code · 404
//         </Typography>
//       </Box>
//     </Box>
//   )
// }

// export default NotFoundPage


// import React, { useEffect, useMemo, useState } from 'react'
// import { Box, Button, Typography } from '@mui/material'
// import { keyframes } from '@mui/system'
// import { useNavigate } from 'react-router-dom'

// /* ---------- Animations ---------- */
// const float = keyframes`
//   0%, 100% { transform: translateY(0); }
//   50%      { transform: translateY(-16px); }
// `
// const pulse = keyframes`
//   0%, 100% { transform: scale(1);   opacity: 0.5; }
//   50%      { transform: scale(1.15); opacity: 0.9; }
// `
// const fadeUp = keyframes`
//   from { opacity: 0; transform: translateY(28px); }
//   to   { opacity: 1; transform: translateY(0); }
// `
// const spin = keyframes`
//   from { transform: rotate(0deg); }
//   to   { transform: rotate(360deg); }
// `
// const twinkle = keyframes`
//   0%, 100% { opacity: 0.15; transform: scale(0.8); }
//   50%      { opacity: 1;    transform: scale(1.3); }
// `
// const shine = keyframes`
//   from { transform: translateX(-120%) skewX(-20deg); }
//   to   { transform: translateX(260%) skewX(-20deg); }
// `
// const gradientShift = keyframes`
//   0%   { background-position: 0% 50%; }
//   50%  { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// `

// const quickLinks = [
//   { label: 'Home', path: '/' },
//   { label: 'Services', path: '/services' },
//   { label: 'Case Studies', path: '/case-studies' },
//   { label: 'Contact', path: '/contact' },
// ]

// function NotFoundPage() {
//   const navigate = useNavigate()
//   const [mouse, setMouse] = useState({ x: 0, y: 0 })

//   // Mouse parallax
//   useEffect(() => {
//     const handle = (e) => {
//       setMouse({
//         x: (e.clientX / window.innerWidth - 0.5) * 2,
//         y: (e.clientY / window.innerHeight - 0.5) * 2,
//       })
//     }
//     window.addEventListener('mousemove', handle)
//     return () => window.removeEventListener('mousemove', handle)
//   }, [])

//   // Random stars (generated once)
//   const stars = useMemo(
//     () =>
//       Array.from({ length: 36 }).map(() => ({
//         top: `${Math.random() * 100}%`,
//         left: `${Math.random() * 100}%`,
//         size: 2 + Math.random() * 3,
//         delay: `${Math.random() * 5}s`,
//         duration: `${2.5 + Math.random() * 3}s`,
//       })),
//     []
//   )

//   const px = (depth) => `translate(${mouse.x * depth}px, ${mouse.y * depth}px)`

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         minHeight: '100vh',
//         width: '100%',
//         overflow: 'hidden',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         px: { xs: 2.5, md: 8 },
//         py: { xs: 6, md: 4 },
//         backgroundColor: 'var(--background-color)',
//         color: 'var(--text-color)',
//         transition: 'background-color 0.3s ease, color 0.3s ease',
//       }}
//     >
//       {/* ---------- Background layers ---------- */}
//       {/* Grid */}
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           backgroundImage:
//             'linear-gradient(var(--primary-dark-light-color) 1px, transparent 1px), linear-gradient(90deg, var(--primary-dark-light-color) 1px, transparent 1px)',
//           backgroundSize: '56px 56px',
//           WebkitMaskImage:
//             'radial-gradient(ellipse at center, #000 20%, transparent 72%)',
//           maskImage: 'radial-gradient(ellipse at center, #000 20%, transparent 72%)',
//           pointerEvents: 'none',
//         }}
//       />
//       {/* Glow blobs */}
//       <Box
//         sx={{
//           position: 'absolute',
//           top: '-15%',
//           left: '-10%',
//           width: { xs: 300, md: 520 },
//           height: { xs: 300, md: 520 },
//           borderRadius: '50%',
//           background: 'var(--primary-main-color)',
//           filter: 'blur(110px)',
//           animation: `${pulse} 8s ease-in-out infinite`,
//         }}
//       />
//       <Box
//         sx={{
//           position: 'absolute',
//           bottom: '-18%',
//           right: '-10%',
//           width: { xs: 320, md: 560 },
//           height: { xs: 320, md: 560 },
//           borderRadius: '50%',
//           background: 'var(--primary-dark-light-color)',
//           filter: 'blur(120px)',
//           animation: `${pulse} 10s ease-in-out infinite`,
//           animationDelay: '2s',
//         }}
//       />
//       {/* Stars */}
//       {stars.map((s, i) => (
//         <Box
//           key={i}
//           sx={{
//             position: 'absolute',
//             top: s.top,
//             left: s.left,
//             width: s.size,
//             height: s.size,
//             borderRadius: '50%',
//             backgroundColor: 'var(--primary-color)',
//             animation: `${twinkle} ${s.duration} ease-in-out infinite`,
//             animationDelay: s.delay,
//             pointerEvents: 'none',
//           }}
//         />
//       ))}

//       {/* ---------- Main content ---------- */}
//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 1,
//           width: '100%',
//           maxWidth: 1180,
//           display: 'flex',
//           flexDirection: { xs: 'column-reverse', md: 'row' },
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           gap: { xs: 4, md: 8 },
//         }}
//       >
//         {/* ----- Left: text ----- */}
//         <Box
//           sx={{
//             flex: 1,
//             textAlign: { xs: 'center', md: 'left' },
//             animation: `${fadeUp} 0.8s ease-out both`,
//           }}
//         >
//           {/* Badge */}
//           <Box
//             sx={{
//               display: 'inline-flex',
//               alignItems: 'center',
//               gap: 1,
//               px: 2,
//               py: 0.8,
//               borderRadius: '999px',
//               border: '1px solid var(--primary-main-color)',
//               backgroundColor: 'var(--primary-dark-light-color)',
//               backdropFilter: 'blur(10px)',
//               mb: 3,
//             }}
//           >
//             <Box
//               sx={{
//                 width: 8,
//                 height: 8,
//                 borderRadius: '50%',
//                 backgroundColor: 'var(--primary-color)',
//                 boxShadow: '0 0 0 4px var(--primary-main-color)',
//                 animation: `${pulse} 2s ease-in-out infinite`,
//               }}
//             />
//             <Typography
//               sx={{
//                 fontSize: 12,
//                 fontWeight: 600,
//                 letterSpacing: '0.14em',
//                 textTransform: 'uppercase',
//                 color: 'var(--primary-dark-color)',
//               }}
//             >
//               Error 404
//             </Typography>
//           </Box>

//           {/* Headline */}
//           <Typography
//             component="h1"
//             sx={{
//               fontWeight: 800,
//               lineHeight: 1.05,
//               letterSpacing: '-0.03em',
//               fontSize: { xs: 40, sm: 56, md: 72 },
//               color: 'var(--text-color)',
//             }}
//           >
//             Lost in{' '}
//             <Box
//               component="span"
//               sx={{
//                 background:
//                   'linear-gradient(90deg, var(--primary-color), var(--primary-dark-color), var(--primary-color))',
//                 backgroundSize: '200% 200%',
//                 WebkitBackgroundClip: 'text',
//                 backgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//                 animation: `${gradientShift} 6s ease infinite`,
//               }}
//             >
//               space?
//             </Box>
//           </Typography>

//           <Typography
//             sx={{
//               mt: 2.5,
//               maxWidth: 480,
//               mx: { xs: 'auto', md: 0 },
//               fontSize: { xs: 15, md: 18 },
//               lineHeight: 1.75,
//               color: 'var(--primary-grey-color)',
//             }}
//           >
//             The page you are looking for has drifted out of orbit. It may have
//             been moved, renamed or never existed. Let us get you back on
//             course.
//           </Typography>

//           {/* Buttons */}
//           <Box
//             sx={{
//               mt: 4,
//               display: 'flex',
//               flexDirection: { xs: 'column', sm: 'row' },
//               gap: 2,
//               justifyContent: { xs: 'center', md: 'flex-start' },
//             }}
//           >
//             <Button
//               onClick={() => navigate('/')}
//               disableElevation
//               sx={{
//                 position: 'relative',
//                 overflow: 'hidden',
//                 px: 4.5,
//                 py: 1.6,
//                 borderRadius: '999px',
//                 textTransform: 'none',
//                 fontWeight: 600,
//                 fontSize: 16,
//                 color: '#fff',
//                 background:
//                   'linear-gradient(135deg, var(--primary-color), var(--primary-dark-color))',
//                 boxShadow: '0 12px 30px var(--primary-main-color)',
//                 transition: 'transform 0.25s ease, box-shadow 0.25s ease',
//                 '&::after': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   width: '40%',
//                   height: '100%',
//                   background: 'rgba(255,255,255,0.35)',
//                   transform: 'translateX(-120%) skewX(-20deg)',
//                 },
//                 '&:hover': {
//                   transform: 'translateY(-3px)',
//                   boxShadow: '0 18px 40px var(--primary-main-color)',
//                   '&::after': { animation: `${shine} 0.8s ease` },
//                 },
//               }}
//             >
//               Take me home →
//             </Button>

//             <Button
//               onClick={() => navigate(-1)}
//               sx={{
//                 px: 4.5,
//                 py: 1.6,
//                 borderRadius: '999px',
//                 textTransform: 'none',
//                 fontWeight: 600,
//                 fontSize: 16,
//                 color: 'var(--text-color)',
//                 border: '1.5px solid var(--primary-main-color)',
//                 backgroundColor: 'var(--primary-dark-light-color)',
//                 backdropFilter: 'blur(10px)',
//                 transition: 'all 0.25s ease',
//                 '&:hover': {
//                   borderColor: 'var(--primary-color)',
//                   transform: 'translateY(-3px)',
//                 },
//               }}
//             >
//               ← Go back
//             </Button>
//           </Box>

//           {/* Quick links */}
//           <Box sx={{ mt: 5 }}>
//             <Typography
//               sx={{
//                 fontSize: 12,
//                 fontWeight: 600,
//                 letterSpacing: '0.14em',
//                 textTransform: 'uppercase',
//                 color: 'var(--primary-grey-color)',
//                 mb: 1.5,
//               }}
//             >
//               Or jump to
//             </Typography>
//             <Box
//               sx={{
//                 display: 'flex',
//                 flexWrap: 'wrap',
//                 gap: 1.2,
//                 justifyContent: { xs: 'center', md: 'flex-start' },
//               }}
//             >
//               {quickLinks.map((l) => (
//                 <Box
//                   key={l.path}
//                   onClick={() => navigate(l.path)}
//                   sx={{
//                     cursor: 'pointer',
//                     px: 2,
//                     py: 0.8,
//                     borderRadius: '999px',
//                     fontSize: 14,
//                     fontWeight: 500,
//                     color: 'var(--primary-dark-color)',
//                     backgroundColor: 'var(--primary-dark-light-color)',
//                     border: '1px solid transparent',
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       borderColor: 'var(--primary-color)',
//                       backgroundColor: 'var(--primary-main-color)',
//                       transform: 'translateY(-2px)',
//                     },
//                   }}
//                 >
//                   {l.label}
//                 </Box>
//               ))}
//             </Box>
//           </Box>
//         </Box>

//         {/* ----- Right: illustration ----- */}
//         <Box
//           sx={{
//             position: 'relative',
//             flex: 1,
//             width: '100%',
//             maxWidth: { xs: 320, sm: 420, md: 520 },
//             aspectRatio: '1 / 1',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             animation: `${fadeUp} 1s ease-out both`,
//           }}
//         >
//           {/* Giant outlined 404 */}
//           <Typography
//             sx={{
//               position: 'absolute',
//               fontWeight: 900,
//               fontSize: { xs: 130, sm: 180, md: 230 },
//               letterSpacing: '-0.05em',
//               lineHeight: 1,
//               color: 'transparent',
//               WebkitTextStroke: '2px var(--primary-main-color)',
//               userSelect: 'none',
//               transform: px(-14),
//               transition: 'transform 0.2s ease-out',
//             }}
//           >
//             404
//           </Typography>

//           {/* Outer dashed orbit */}
//           <Box
//             sx={{
//               position: 'absolute',
//               width: '94%',
//               height: '94%',
//               borderRadius: '50%',
//               border: '1.5px dashed var(--primary-main-color)',
//               animation: `${spin} 40s linear infinite`,
//             }}
//           />

//           {/* Planet group */}
//           <Box
//             sx={{
//               position: 'relative',
//               width: '56%',
//               height: '56%',
//               transform: px(18),
//               transition: 'transform 0.2s ease-out',
//             }}
//           >
//             <Box
//               sx={{
//                 position: 'absolute',
//                 inset: 0,
//                 animation: `${float} 5s ease-in-out infinite`,
//               }}
//             >
//               {/* Planet */}
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   inset: 0,
//                   borderRadius: '50%',
//                   background:
//                     'radial-gradient(circle at 30% 28%, rgba(255,255,255,0.55), transparent 38%), linear-gradient(145deg, var(--primary-color) 0%, var(--primary-dark-color) 100%)',
//                   boxShadow:
//                     '0 30px 70px var(--primary-main-color), inset -18px -22px 40px rgba(0,0,0,0.25)',
//                 }}
//               >
//                 {/* Craters */}
//                 {[
//                   { t: '22%', l: '58%', s: '16%' },
//                   { t: '52%', l: '22%', s: '22%' },
//                   { t: '68%', l: '60%', s: '12%' },
//                 ].map((c, i) => (
//                   <Box
//                     key={i}
//                     sx={{
//                       position: 'absolute',
//                       top: c.t,
//                       left: c.l,
//                       width: c.s,
//                       height: c.s,
//                       borderRadius: '50%',
//                       backgroundColor: 'rgba(0,0,0,0.14)',
//                       boxShadow: 'inset 2px 3px 6px rgba(0,0,0,0.25)',
//                     }}
//                   />
//                 ))}
//               </Box>

//               {/* Ring */}
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '50%',
//                   left: '50%',
//                   width: '170%',
//                   height: '46%',
//                   transform: 'translate(-50%, -50%) rotate(-22deg)',
//                   borderRadius: '50%',
//                   border: '6px solid var(--primary-color)',
//                   borderLeftColor: 'transparent',
//                   borderBottomColor: 'var(--primary-main-color)',
//                   opacity: 0.9,
//                 }}
//               />
//             </Box>
//           </Box>

//           {/* Orbiting satellite */}
//           <Box
//             sx={{
//               position: 'absolute',
//               width: '78%',
//               height: '78%',
//               animation: `${spin} 14s linear infinite`,
//             }}
//           >
//             <Box
//               sx={{
//                 position: 'absolute',
//                 top: -10,
//                 left: '50%',
//                 width: 22,
//                 height: 22,
//                 ml: '-11px',
//                 borderRadius: '6px',
//                 background:
//                   'linear-gradient(135deg, var(--primary-color), var(--primary-dark-color))',
//                 boxShadow: '0 0 20px var(--primary-color)',
//                 transform: 'rotate(45deg)',
//               }}
//             />
//           </Box>

//           {/* Floating chips */}
//           <Box
//             sx={{
//               position: 'absolute',
//               top: '8%',
//               right: '2%',
//               px: 1.8,
//               py: 0.8,
//               borderRadius: '14px',
//               fontSize: 13,
//               fontWeight: 600,
//               color: 'var(--primary-dark-color)',
//               backgroundColor: 'var(--primary-dark-light-color)',
//               border: '1px solid var(--primary-main-color)',
//               backdropFilter: 'blur(10px)',
//               animation: `${float} 6s ease-in-out infinite`,
//               animationDelay: '1s',
//               transform: px(26),
//             }}
//           >
//             Page not found
//           </Box>
//           <Box
//             sx={{
//               position: 'absolute',
//               bottom: '10%',
//               left: '0%',
//               px: 1.8,
//               py: 0.8,
//               borderRadius: '14px',
//               fontSize: 13,
//               fontWeight: 600,
//               color: 'var(--primary-dark-color)',
//               backgroundColor: 'var(--primary-dark-light-color)',
//               border: '1px solid var(--primary-main-color)',
//               backdropFilter: 'blur(10px)',
//               animation: `${float} 7s ease-in-out infinite`,
//               animationDelay: '2s',
//               transform: px(-22),
//             }}
//           >
//             Signal lost 📡
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   )
// }

// export default NotFoundPage


// import React from 'react';
// import {
//   Box,
//   Button,
//   Container,
//   Typography,
//   Stack,
// } from '@mui/material';
// import {
//   HomeRounded,
//   ArrowBackRounded,
//   SearchOffRounded,
// } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';

// function NotFoundPage() {
//   const navigate = useNavigate();

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         backgroundColor: 'var(--background-color)',
//         color: 'var(--text-color)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         overflow: 'hidden',
//         position: 'relative',
//         py: 5,
//         px: 2,
//       }}
//     >
//       {/* Decorative Background Elements */}
//       <Box
//         sx={{
//           position: 'absolute',
//           width: 350,
//           height: 350,
//           borderRadius: '50%',
//           background: 'var(--primary-main-color)',
//           filter: 'blur(100px)',
//           top: '-120px',
//           left: '-100px',
//           pointerEvents: 'none',
//         }}
//       />

//       <Box
//         sx={{
//           position: 'absolute',
//           width: 350,
//           height: 350,
//           borderRadius: '50%',
//           background: 'var(--primary-dark-light-color)',
//           filter: 'blur(100px)',
//           bottom: '-120px',
//           right: '-100px',
//           pointerEvents: 'none',
//         }}
//       />

//       <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
//         <Box
//           sx={{
//             textAlign: 'center',
//             maxWidth: 650,
//             mx: 'auto',
//           }}
//         >
//           {/* Icon */}
//           <Box
//             sx={{
//               width: 90,
//               height: 90,
//               borderRadius: '28px',
//               backgroundColor: 'var(--primary-dark-light-color)',
//               border: '1px solid var(--primary-main-color)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mx: 'auto',
//               mb: 3,
//               transform: 'rotate(-8deg)',
//             }}
//           >
//             <SearchOffRounded
//               sx={{
//                 fontSize: 48,
//                 color: 'var(--primary-color)',
//               }}
//             />
//           </Box>

//           {/* 404 Text */}
//           <Typography
//             component="h1"
//             sx={{
//               fontSize: {
//                 xs: '110px',
//                 sm: '160px',
//                 md: '190px',
//               },
//               fontWeight: 900,
//               lineHeight: 0.95,
//               letterSpacing: '-10px',
//               background:
//                 'linear-gradient(135deg, var(--primary-color), var(--primary-dark-color))',
//               backgroundClip: 'text',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent',
//               mb: 2,
//             }}
//           >
//             404
//           </Typography>

//           {/* Heading */}
//           <Typography
//             component="h2"
//             sx={{
//               fontSize: { xs: 26, sm: 34 },
//               fontWeight: 800,
//               mb: 1.5,
//               color: 'var(--text-color)',
//             }}
//           >
//             Oops! Page Not Found
//           </Typography>

//           {/* Description */}
//           <Typography
//             sx={{
//               color: 'var(--primary-grey-color)',
//               fontSize: { xs: 14, sm: 16 },
//               lineHeight: 1.8,
//               maxWidth: 470,
//               mx: 'auto',
//               mb: 4,
//             }}
//           >
//             The page you're looking for might have been removed,
//             had its name changed, or is temporarily unavailable.
//             Let's get you back on track!
//           </Typography>

//           {/* Buttons */}
//           <Stack
//             direction={{ xs: 'column', sm: 'row' }}
//             spacing={2}
//             justifyContent="center"
//             alignItems="center"
//           >
//             <Button
//               variant="contained"
//               startIcon={<HomeRounded />}
//               onClick={() => navigate('/')}
//               sx={{
//                 px: 4,
//                 py: 1.5,
//                 borderRadius: '12px',
//                 fontWeight: 700,
//                 fontSize: 15,
//                 textTransform: 'none',
//                 backgroundColor: 'var(--primary-color)',
//                 color: '#fff',
//                 boxShadow: '0 8px 25px var(--primary-main-color)',
//                 '&:hover': {
//                   backgroundColor: 'var(--primary-dark-color)',
//                   color: 'var(--background-color)',
//                   transform: 'translateY(-3px)',
//                 },
//                 transition: 'all 0.3s ease',
//               }}
//             >
//               Back to Home
//             </Button>

//             <Button
//               variant="outlined"
//               startIcon={<ArrowBackRounded />}
//               onClick={() => {
//                 if (window.history.length > 1) {
//                   navigate(-1);
//                 } else {
//                   navigate('/');
//                 }
//               }}
//               sx={{
//                 px: 4,
//                 py: 1.5,
//                 borderRadius: '12px',
//                 fontWeight: 700,
//                 fontSize: 15,
//                 textTransform: 'none',
//                 color: 'var(--primary-dark-color)',
//                 borderColor: 'var(--primary-color)',
//                 '&:hover': {
//                   borderColor: 'var(--primary-color)',
//                   backgroundColor: 'var(--primary-dark-light-color)',
//                   transform: 'translateY(-3px)',
//                 },
//                 transition: 'all 0.3s ease',
//               }}
//             >
//               Go Back
//             </Button>
//           </Stack>

//           {/* Footer */}
//           <Typography
//             sx={{
//               mt: 7,
//               fontSize: 13,
//               color: 'var(--primary-grey-color)',
//               letterSpacing: 0.5,
//             }}
//           >
//             Lost? Don't worry, we're here to help.
//           </Typography>
//         </Box>
//       </Container>
//     </Box>
//   );
// }

// export default NotFoundPage;



import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import {
  HomeRounded,
  ArrowBackRounded,
  ExploreRounded,
  ErrorOutlineRounded,
  NorthEastRounded,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'var(--background-color)',
        color: 'var(--text-color)',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        py: { xs: 5, md: 8 },
      }}
    >
      {/* Background decoration */}
      <Box
        sx={{
          position: 'absolute',
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: 'var(--primary-main-color)',
          filter: 'blur(130px)',
          top: '-200px',
          right: '-100px',
          opacity: 0.7,
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: 'var(--primary-dark-light-color)',
          filter: 'blur(100px)',
          bottom: '-200px',
          left: '-100px',
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: { xs: 'column-reverse', md: 'row' },
            gap: { xs: 5, md: 3 },
          }}
        >
          {/* LEFT CONTENT */}
          <Box
            sx={{
              flex: 1,
              textAlign: { xs: 'center', md: 'left' },
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: 10,
                border: '1px solid var(--primary-main-color)',
                backgroundColor: 'var(--primary-dark-light-color)',
                mb: 3,
              }}
            >
              <ErrorOutlineRounded
                sx={{ color: 'var(--primary-color)', fontSize: 18 }}
              />
              <Typography
                sx={{
                  color: 'var(--primary-color)',
                  fontSize: 12,
                  fontWeight: 800,
                  letterSpacing: 1.5,
                }}
              >
                ERROR 404
              </Typography>
            </Box>

            <Typography
              component="h1"
              sx={{
                fontSize: { xs: 38, sm: 48, md: 62 },
                fontWeight: 900,
                lineHeight: 1.12,
                letterSpacing: -2,
                mb: 2,
              }}
            >
              Looks like you're
              <Box
                component="span"
                sx={{
                  display: 'block',
                  background:
                    'linear-gradient(90deg, var(--primary-color), #79CEBE)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                lost in space!
              </Box>
            </Typography>

            <Typography
              sx={{
                color: 'var(--primary-grey-color)',
                fontSize: { xs: 14, sm: 16 },
                lineHeight: 1.9,
                maxWidth: 430,
                mx: { xs: 'auto', md: 0 },
                mb: 4,
              }}
            >
              The page you're trying to reach has disappeared into
              the unknown. Don't worry, even the best explorers
              sometimes take a wrong turn.
            </Typography>

            <Box
              sx={{
                display: 'flex',
                gap: 2,
                flexWrap: 'wrap',
                justifyContent: { xs: 'center', md: 'flex-start' },
              }}
            >
              <Button
                onClick={() => navigate('/')}
                variant="contained"
                endIcon={<NorthEastRounded />}
                sx={{
                  backgroundColor: 'var(--primary-color)',
                  color: '#fff',
                  borderRadius: '12px',
                  px: 3.5,
                  py: 1.5,
                  fontWeight: 700,
                  textTransform: 'none',
                  fontSize: 15,
                  boxShadow: '0 10px 30px var(--primary-main-color)',
                  '&:hover': {
                    backgroundColor: 'var(--primary-color)',
                    filter: 'brightness(0.9)',
                    transform: 'translateY(-3px)',
                  },
                  transition: '0.3s',
                }}
              >
                Back to Homepage
              </Button>

              <Button
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackRounded />}
                sx={{
                  color: 'var(--primary-dark-color)',
                  border: '1px solid var(--primary-main-color)',
                  borderRadius: '12px',
                  px: 3,
                  py: 1.5,
                  fontWeight: 700,
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: 'var(--primary-dark-light-color)',
                  },
                }}
              >
                Go Back
              </Button>
            </Box>

            <Typography
              sx={{
                mt: 5,
                fontSize: 12,
                color: 'var(--primary-grey-color)',
              }}
            >
              <ExploreRounded
                sx={{
                  fontSize: 16,
                  verticalAlign: 'middle',
                  mr: 1,
                  color: 'var(--primary-color)',
                }}
              />
              Every journey has a way back home.
            </Typography>
          </Box>

          {/* RIGHT ILLUSTRATION */}
          <Box
            sx={{
              flex: 1,
              width: '100%',
              minHeight: { xs: 310, sm: 390, md: 480 },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
            }}
          >
            {/* Outer orbit */}
            <Box
              sx={{
                position: 'absolute',
                width: { xs: 270, sm: 380, md: 430 },
                height: { xs: 270, sm: 380, md: 430 },
                borderRadius: '50%',
                border: '1px dashed var(--primary-grey-color)',
                opacity: 0.5,
              }}
            />

            {/* Middle circle */}
            <Box
              sx={{
                position: 'absolute',
                width: { xs: 220, sm: 310, md: 350 },
                height: { xs: 220, sm: 310, md: 350 },
                borderRadius: '50%',
                background:
                  'linear-gradient(135deg, var(--primary-dark-light-color), var(--primary-main-color))',
                border: '1px solid var(--primary-main-color)',
                boxShadow: '0 30px 80px var(--primary-dark-light-color)',
              }}
            />

            {/* Main 404 */}
            <Box
              sx={{
                position: 'relative',
                zIndex: 2,
                textAlign: 'center',
                transform: 'rotate(-7deg)',
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: 110, sm: 155, md: 185 },
                  fontWeight: 900,
                  lineHeight: 1,
                  letterSpacing: -12,
                  color: 'var(--primary-color)',
                  textShadow: '8px 12px 0 var(--primary-dark-light-color)',
                }}
              >
                404
              </Typography>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 800,
                  letterSpacing: 5,
                  color: 'var(--primary-grey-color)',
                  mt: 1,
                }}
              >
                PAGE NOT FOUND
              </Typography>
            </Box>

            {/* Floating top badge */}
            <Box
              sx={{
                position: 'absolute',
                top: { xs: 15, sm: 35 },
                right: { xs: 0, sm: 15 },
                width: 65,
                height: 65,
                borderRadius: '20px',
                backgroundColor: 'var(--background-color)',
                border: '1px solid var(--primary-main-color)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 12px 35px var(--primary-dark-light-color)',
                transform: 'rotate(12deg)',
                zIndex: 3,
              }}
            >
              <ExploreRounded
                sx={{ color: 'var(--primary-color)', fontSize: 35 }}
              />
            </Box>

            {/* Floating bottom badge */}
            <Box
              sx={{
                position: 'absolute',
                bottom: { xs: 15, sm: 35 },
                left: { xs: 0, sm: 15 },
                px: 2,
                py: 1.5,
                borderRadius: '16px',
                backgroundColor: 'var(--background-color)',
                border: '1px solid var(--primary-main-color)',
                boxShadow: '0 12px 35px var(--primary-dark-light-color)',
                zIndex: 3,
                transform: 'rotate(-5deg)',
              }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  color: 'var(--primary-grey-color)',
                  fontWeight: 600,
                }}
              >
                CURRENT STATUS
              </Typography>
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 800,
                  color: 'var(--primary-color)',
                  mt: 0.5,
                }}
              >
                Page unavailable
              </Typography>
            </Box>

            {/* Decorative dots */}
            <Box
              sx={{
                position: 'absolute',
                top: '15%',
                left: '15%',
                width: 13,
                height: 13,
                borderRadius: '50%',
                backgroundColor: 'var(--primary-color)',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: '15%',
                right: '13%',
                width: 9,
                height: 9,
                borderRadius: '50%',
                backgroundColor: 'var(--primary-color)',
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default NotFoundPage;
